var _defs, _ellipse, _style, _circle, _circle2, _path, _path2, _polyline, _line, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCadImportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "39px",
    viewBox: "0 0 38 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CadImportIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "iPad-Pro-11---Patient-Information",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chart",
    transform: "translate(-52.000000, -142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(52.000000, 142.000000)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#0a59a7",
    cx: 19,
    cy: 19.5135135,
    rx: 19,
    ry: 19.5135135
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "stethoscope"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "150 200 300 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n.st0 {\n  fill: none;\n  stroke: #000000;\n  stroke-width: 11;\n  stroke-miterlimit: 10;\n}\n.st1 {\n  fill: none;\n  stroke: #000000;\n  stroke-width: 11;\n  stroke-linecap: round;\n  stroke-miterlimit: 10;\n}\n.st2 {\n  fill: none;\n  stroke: #000000;\n  stroke-width: 11;\n  stroke-linecap: square;\n  stroke-miterlimit: 10;\n}\n              ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 246.47,
    cy: 456.4,
    r: 30.41
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 366.18,
    cy: 456.4,
    r: 30.41
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.97,450.89h-4.25c-10.14,0-18.36-8.22-18.36-18.36V324.42c0-10.18,8.26-18.44,18.44-18.44h108.1                                 c10.15,0,18.37,8.23,18.37,18.37v126.54h-57.95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M417.67,450.34"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "407.36,450.34 407.36,390.86 336.37,390.86 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 395.98,
    y1: 450.34,
    x2: 420.36,
    y2: 450.34
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.37,342.51h29.65c2.76,0,5.37,1.21,7.16,3.3l34.18,40.05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.45,380.42h-14.26c-4.23,0-7.65-3.43-7.65-7.65v-12.52c0-4.23,3.43-7.65,7.65-7.65h14.26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.73,380.42v14.26c0,4.23-3.43,7.65-7.65,7.65h-12.52c-4.23,0-7.65-3.43-7.65-7.65v-14.26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.9,352.47v-14.26c0-4.23,3.43-7.65,7.65-7.65h12.52c4.23,0,7.65,3.43,7.65,7.65v14.26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.73,352.6h14.26c4.23,0,7.65,3.43,7.65,7.65v12.52c0,4.23-3.43,7.65-7.65,7.65h-14.26"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadImportIcon);
export default __webpack_public_path__ + "static/media/CadImportIcon.ba0d12e84740fbb5bae9817630fd91f4.svg";
export { ForwardRef as ReactComponent };